// modules
import React from 'react';
import { observer } from 'mobx-react';
import LocaleService from 'modules/Localization';
import Validation from 'modules/Validation';
// store
import { useStore } from 'modules/Stores';
// components
import {
  LoadingBlock,
  View,
} from '@upstox/upstox-ui';
// styles
import * as css from '../../styles';

const MarketLotCell: React.FC = () => {
  const {
    scripData,
    loading,
  } = useStore('OptionChainStore');

  const isCommodity = Validation.isCommodity(scripData?.segment);
  const marketLot = isCommodity ? 1 : scripData?.lotSize || 1;

  return (
    <View flexDirection="column">
      <View css={css.dataHeading}>{LocaleService.translate('MARKET_LOT')}</View>
      {loading ? (
        <LoadingBlock height={14} width={40} />
      ) : (
        <View css={css.dataValue}>{marketLot}</View>
      )}
    </View>
  );
};

export default observer(MarketLotCell);
